import React, { useEffect, useState } from 'react';
import { fetchConToken } from 'helpers/fetch';
import { useUIUtils } from 'hooks/useUIUtils';
import { currency } from 'resources/utilities';
import { avisarError, Campo, cargar, sucursalActual, Tarjeta } from '../comun';

const fechaLocal = (fecha = new Date()) => {
    const mes = String(fecha.getMonth() + 1).padStart(2, '0');
    const dia = String(fecha.getDate()).padStart(2, '0');
    return `${fecha.getFullYear()}-${mes}-${dia}`;
};

const inicioMes = () => {
    const fecha = new Date();
    return fechaLocal(new Date(fecha.getFullYear(), fecha.getMonth(), 1));
};

const diferencia = (cierre, esperado) => Number(cierre || 0) - Number(esperado || 0);

const Reporte = ({ reporte }) => (
    <Tarjeta titulo={`Reporte ${reporte.caja || ''}`}>
        <p>Del {String(reporte.fecha_Inicio || '').replace('T', ' ').slice(0, 16)} al {String(reporte.fecha_Fin || '').replace('T', ' ').slice(0, 16)}</p>
        <div className='row'>
            <div className='col-md-3'>Ventas: {reporte.cantidad_Ventas} / {currency(reporte.total_Ventas)}</div>
            <div className='col-md-3'>Cobros: {reporte.cantidad_Cobros} / {currency(reporte.total_Cobros)}</div>
            <div className='col-md-3'>Cant Devoluciones: {reporte.cantidad_Devoluciones} </div>
            <div className='col-md-3'>Total Devoluciones: {currency(reporte.total_Devoluciones)}</div>
            <div className='col-md-3'>Cambio: {currency(reporte.total_Cambio)}</div>
            <div className='col-md-3'>Retiros: {currency(reporte.total_Retiros)}</div>
            <div className='col-md-3'>Ingresos: {currency(reporte.total_Ingresos)}</div>
            <div className='col-md-3'>Apertura: {currency(reporte.total_Apertura)}</div>
            <div className='col-md-3'>Cierre: {currency(reporte.total_Cierre)}</div>
            <div className='col-md-3'>Esperado: {currency(reporte.total_Esperado)}</div>
            <div className='col-md-3'>Diferencia: {currency(diferencia(reporte.total_Cierre, reporte.total_Esperado))}</div>
        </div>
        <table className='table table-sm mt-3'>
            <thead>
                <tr>
                    <th>Forma</th><th>Apertura</th><th>Ventas</th><th>Cambio</th><th>Cobros</th><th>Devoluciones</th><th>Retiros</th><th>Ingresos</th><th>Cierre</th><th>Esperado</th><th>Diferencia</th>
                </tr>
            </thead>
            <tbody>
                {(reporte.formas || []).map((item) => (
                    <tr key={item.forma_Cobro_Id}>
                        <td>{item.forma_Cobro}</td>
                        <td>{currency(item.apertura)}</td>
                        <td>{currency(item.ventas)}</td>
                        <td>{currency(item.cambio)}</td>
                        <td>{currency(item.cobros)}</td>
                        <td>{currency(item.devoluciones)}</td>
                        <td>{currency(item.retiros)}</td>
                        <td>{currency(item.ingresos)}</td>
                        <td>{currency(item.cierre)}</td>
                        <td>{currency(item.esperado)}</td>
                        <td>{currency(diferencia(item.cierre, item.esperado))}</td>
                    </tr>
                ))}
            </tbody>
        </table>
    </Tarjeta>
);

const Cortes = () => {
    const { changeGlobalTitle } = useUIUtils();
    const [cajas, setCajas] = useState([]);
    const [cortes, setCortes] = useState([]);
    const [consultado, setConsultado] = useState(false);
    const [reporte, setReporte] = useState(null);
    const [corteId, setCorteId] = useState(0);
    const [filtro, setFiltro] = useState({ cajaId: '0', fechaInicio: inicioMes(), fechaFin: fechaLocal() });

    useEffect(() => {
        changeGlobalTitle('Cortes de caja', 'Elija la caja y el periodo. El reporte corresponde al corte seleccionado.');
        cargar(`pv/PvCajas/GetList?sucursal_Id=${sucursalActual()}&almacen_id=0&paginas=0&totalXpagina=200&busqueda=`).then(setCajas);
    }, [changeGlobalTitle]);

    function nombreCaja(id) {
        return cajas.find((item) => String(item.id) === String(id))?.nombre || id;
    }

    function consultar() {
        setReporte(null);
        setCorteId(0);
        cargar(`pv/PvCajas/Movimientos?sucursal_id=${sucursalActual()}&caja_id=${filtro.cajaId || 0}&tipo=C&fechaInicio=${filtro.fechaInicio}&fechaFin=${filtro.fechaFin}&paginas=1&totalXpagina=100`).then(setCortes);
        setConsultado(true);
    }

    function verReporte(movimiento) {
        setCorteId(movimiento.id);
        fetchConToken(`pv/PvCajas/Reporte?sucursal_id=${sucursalActual()}&mov_caja_id=${movimiento.id}`).then((response) => {
            if (!avisarError(response)) setReporte(response);
        });
    }

    return (
        <div className='container-fluid'>
            <Tarjeta titulo='Filtros'>
                <div className='row'>
                    <div className='col-md-4'>
                        <Campo label='Caja'>
                            <select className='form-select' value={filtro.cajaId} onChange={({ target }) => setFiltro({ ...filtro, cajaId: target.value })}>
                                <option value='0'>Todas</option>
                                {cajas.map((item) => <option key={item.id} value={item.id}>{item.nombre}</option>)}
                            </select>
                        </Campo>
                    </div>
                    <div className='col-md-3'><Campo label='Desde'><input type='date' className='form-control' value={filtro.fechaInicio} onChange={({ target }) => setFiltro({ ...filtro, fechaInicio: target.value })} /></Campo></div>
                    <div className='col-md-3'><Campo label='Hasta'><input type='date' className='form-control' value={filtro.fechaFin} onChange={({ target }) => setFiltro({ ...filtro, fechaFin: target.value })} /></Campo></div>
                </div>
                <button type='button' className='btn btn-outline-primary' onClick={consultar}>Consultar</button>
            </Tarjeta>
            {consultado && (
                <Tarjeta titulo='Cortes'>
                    <table className='table table-sm'>
                        <thead><tr><th>Caja</th><th>Fecha</th><th>Hora</th><th></th></tr></thead>
                        <tbody>
                            {cortes.length === 0 ? <tr><td colSpan='4'>No hay cortes en este periodo</td></tr> : cortes.map((item) => (
                                <tr key={item.id} className={corteId === item.id ? 'table-active' : ''}>
                                    <td>{nombreCaja(item.caja_Id)}</td>
                                    <td>{String(item.fecha || '').slice(0, 10)}</td>
                                    <td>{item.hora}</td>
                                    <td><button type='button' className='btn btn-link p-0' onClick={() => verReporte(item)}>Ver reporte</button></td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </Tarjeta>
            )}
            {reporte && <Reporte reporte={reporte} />}
        </div>
    );
};

export { Cortes };
